import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1a1a1a 0%, #000000 100%);
  color: var(--highlight-color);
  padding: 3rem 2rem 2rem;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--primary-color), transparent);
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const CompanyName = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  margin: 0;
  letter-spacing: 1px;
`;

const Copyright = styled.p`
  margin: 0;
  color: #cccccc;
  font-size: 0.9rem;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 1rem;

  a {
    color: var(--highlight-color);
    text-decoration: none;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 25px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
      transition: left 0.5s ease;
    }

    &:hover {
      color: var(--primary-color);
      background: rgba(255, 255, 255, 0.05);
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

      &::before {
        left: 100%;
      }
    }
  }

  span {
    color: var(--highlight-color);
    font-weight: 500;
    padding: 0.5rem 1rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 25px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    }
  }
`;

const FooterDivider = styled.div`
  width: 100px;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--primary-color), transparent);
  margin: 1rem 0;
`;

const ComplianceSection = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const ComplianceTitle = styled.h4`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ComplianceLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

const ComplianceLogo = styled.a`
  display: inline-block;
  text-decoration: none;

  img {
    height: 80px;
    width: auto;
  }

  @media (max-width: 768px) {
    img {
      height: 70px;
    }
  }
`;

const CompanyDetails = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const CompanyHouseNumber = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.5px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <CompanyInfo>
          <CompanyName>Nova Elite Homes</CompanyName>
          <Copyright>&copy; 2025 Nova Elite Homes. All rights reserved.</Copyright>
        </CompanyInfo>
        
        <FooterDivider />
        
        <FooterLinks>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
        </FooterLinks>

        <ComplianceSection>
          <ComplianceTitle>A member of</ComplianceTitle>
          <ComplianceLogos>
            <ComplianceLogo 
              href="https://www.theprs.co.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Property Redress Scheme - Member"
            >
              <img 
                src="/images/Property-Redress-Scheme-logo.png" 
                alt="Property Redress Scheme Member" 
              />
            </ComplianceLogo>
          </ComplianceLogos>
        </ComplianceSection>

        <CompanyDetails>
          <CompanyHouseNumber>Company House Number: 15729312</CompanyHouseNumber>
        </CompanyDetails>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;